import { createRouter, createWebHistory } from 'vue-router';
import MainPage from '../components/main/MainPage.vue';
import ProcessPage from '../components/process/ProcessPage.vue';
import ServiceDetailPage from '../components/service/ServiceDetailPage.vue';
import CasesPage from '../components/cases/CasesPage.vue';
import FaqPage from '../components/faq/FaqPage.vue';

const routes = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage,
  },
  {
    path: '/process',
    name: 'ProcessPage',
    component: ProcessPage,
  },
  {
    path: '/cases',
    name: 'CasesPage',
    component: CasesPage,
  },
  {
    path: '/faq',
    name: 'FaqPage',
    component: FaqPage,
  },
  {
    path: '/blog',
    name: 'BlogServicePage',
    component: ServiceDetailPage,
    props: { serviceId: 'blog' },
  },
  {
    path: '/instagram',
    name: 'InstagramServicePage',
    component: ServiceDetailPage,
    props: { serviceId: 'instagram' },
  },
  {
    path: '/purchase-review',
    name: 'PurchaseReviewServicePage',
    component: ServiceDetailPage,
    props: { serviceId: 'purchase-review' },
  },
  {
    path: '/map-review',
    name: 'MapReviewServicePage',
    component: ServiceDetailPage,
    props: { serviceId: 'map-review' },
  },
  {
    path: '/app-review',
    name: 'AppReviewServicePage',
    component: ServiceDetailPage,
    props: { serviceId: 'app-review' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0, behavior: 'smooth' };
  },
});

export default router;
